<template>
  <div class="form-group">
    <select
      class="form-control"
      :id="`select-${this._uid}`"
      data-minimum-results-for-search="10"
      data-placeholder="None"
      data-allow-clear="true"
      :disabled="disabled || !canEdit"
      style="width: 100%"
    >
      <option value></option>
    </select>
    <under-label :id="'input-text-' + this._uid">
      <slot></slot>
      <span
        v-if="required"
        class="required"
        data-toggle="tooltip"
        data-placement="bottom"
        title="Required"
      >*</span>
    </under-label>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UnderLabel from "./_UnderLabel.vue";

/* eslint-disable no-undef */
export default {
  name: "vue-ez-select2",
  components: {
    UnderLabel
  },
  props: ["options", "value", "error", "hideLabel", "required", "disabled"],
  mounted() {
    /* eslint-disable no-undef */
    $('[data-toggle="tooltip"]').tooltip();

    if (this.options.length > 0) {
      var vm = this;
      $(`#select-${this._uid}`)
        .select2({
          data: this.options
        })
        .val(this.value)
        .trigger("change")
        .on("change", function() {
          vm.$emit("input", this.value);
        });
    } else {
      $(`#select-${this._uid}`).select2();
    }

    // console.log(`mounted options: ${this.options.length}`)
    // console.log(`mounted value: ${this.value}`)
  },
  watch: {
    value: function(value) {
      $(`#select-${this._uid}`)
        .val(value)
        .trigger("change");
    },
    options: function(opt) {
      // console.log(`options options: ${this.options}`)
      // console.log(`options value: ${this.value}`)
      var vm = this;
      $(`#select-${this._uid}`)
        .select2({
          data: opt
        })
        .val(this.value)
        .trigger("change")
        .on("change", function() {
          vm.$emit("input", this.value);
        });
    }
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" })
  },
  destroyed() {
    $(`#select-${this._uid}`)
      .off()
      .select2("destroy");
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.select2-container--default
  .select2-selection--single
  .select2-selection__arrow {
  margin-top: -0.55rem;
}
.select2-container .select2-selection--single {
  border: 0;
  background-color: transparent;
  border-radius: 0 !important;
  border: solid 0px $gray-800;
  border-bottom: solid 1px $gray-400;
  box-shadow: 0 0 0;
  font-size: 1.25rem !important;
  font-weight: bold;
  height: auto;
  min-height: 1rem;
  margin: 0 !important;
}
.select2-container--default.select2-container--disabled
  .select2-selection--single {
  background-color: transparent;
  > .select2-selection__rendered {
    color: rgb(127, 127, 127) !important;
  }
}
.select2-selection__rendered {
  font-size: 1.25rem !important;
  // color: $body-color !important;
  margin: 0 !important;
  padding-left: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.invalid-feedback {
  display: block;
}
</style>
